import styled from '@emotion/styled';
import { BREAKPOINTS } from '@ordermentum/ui-constants';
import C from '@ordermentum/ui-constants';

const url = `${C.IMAGE_URL}/register-background.jpg`;

const Background = styled('div')`
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  z-index: 10;
  position: absolute;
  padding: 20px;
  background-color: white;
  display: flex;
  min-height: 100%;
  height: auto;
  @media (min-width: ${BREAKPOINTS.MOBILE_MAX}) {
    background-image: url(${url});
  }
`;

const WhiteBackground = styled('div')`
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  z-index: 99999;
  position: absolute;
  padding: 20px;
  background-color: white;
  display: flex;
  min-height: 100%;
  height: auto;
`;

const BackgroundWithOverlay = styled('div')`
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  z-index: 10;
  position: absolute;
  display: flex;
  background-image: url(${url});
  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: black;
    opacity: 0.7;
  }
`;
export default Background;

export { BackgroundWithOverlay, WhiteBackground };
